import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import SignIn from './pages/Signin';
import Header from './components/Header';
import UserPage from './pages/Userpage';
import DetailPage from './pages/DetailPage';  
import AdminDashboard from './Admin/AdminDashboard'; 
//import SettingsPage from './pages/SettingsPage';
import AppointmentHistory from './pages/AppointmentHistory';
import EditProfile from './pages/EditProfile';
import UserProfile from './pages/UserProfile';  
import CarDetailList from './Admin/CarDetailList';  
import BookingList from './Admin/BookingList';  
import ManufacturerManager from './Admin/ManufacturerManager';
import Contactus from './pages/ContacUs';
import AboutUs from './pages/About Us';
import InitialAboutUs from './pages/Initial Aboutus';
import InitialContactUs from './pages/Initial ContactUs';
import ProtectedRoute from './pages/ProtectedRoute';
import AdminRoute from './pages/AdminRoute';

function App() {
  return (
        <Router>
      <ConditionalHeader />
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/initial-about-us" element={<InitialAboutUs />} />
        <Route path="/initial-contact-us" element={<InitialContactUs />} />
        
        {/* Protected user routes */}
        <Route path="/userpage" element={
          <ProtectedRoute>
            <UserPage />
          </ProtectedRoute>
        } />
        <Route path="/detail-page" element={
          <ProtectedRoute>
            <DetailPage />
          </ProtectedRoute>
        } />
        {/* <Route path="/settings" element={
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        } /> */}
        <Route path="/appointment-history" element={
          <ProtectedRoute>
            <AppointmentHistory />
          </ProtectedRoute>
        } />
        <Route path="/edit-profile" element={
          <ProtectedRoute>
            <EditProfile />
          </ProtectedRoute>
        } />
        <Route path="/user-profile" element={
          <ProtectedRoute>
            <UserProfile />
          </ProtectedRoute>
        } />
        <Route path="/contact-us" element={
          <ProtectedRoute>
            <Contactus />
          </ProtectedRoute>
        } />
        <Route path="/about-us" element={
          <ProtectedRoute>
            <AboutUs />
          </ProtectedRoute>
        } />
        
        {/* Admin routes */}
        <Route path="/admin/dashboard" element={
          <AdminRoute>
            <AdminDashboard />
          </AdminRoute>
        } />
        <Route path="/admin/car-details" element={
          <AdminRoute>
            <CarDetailList />
          </AdminRoute>
        } />
        <Route path="/admin/bookings" element={
          <AdminRoute>
            <BookingList />
          </AdminRoute>
        } />
        <Route path="/admin/manufacture" element={
          <AdminRoute>
            <ManufacturerManager />
          </AdminRoute>
        } />
        {/* <Route path="/admin/settings" element={
          <AdminRoute>
            <SettingsPage />
          </AdminRoute>
        } /> */}
      </Routes>
    </Router>
  );
}
 

 
const ConditionalHeader = () => {
  const location = useLocation();

   
  return location.pathname === '/' ? <Header /> : null;
};

export default App;
